import { BrowserRouter, Route, Routes } from "react-router-dom";
import { TopPage } from "../pages/TopPage";
import { LoginPage } from "../pages/LoginPage";
import { OAuthCallbackPage } from "../pages/OAuthCallbackPage";
import { ProtectedRoute } from "./ProtectedRoute";
import { PublicRoute } from "./PublicRoute";
import { NoveltyCookieOrderPage } from "../pages/NoveltyCookieOrderPage";
import { PaymentConfirmPage } from "../pages/PaymentConfirmPage";
import { ThanksPage } from "../pages/ThanksPage";
import { IrastPlateOrderPage } from "../pages/IrastPlateOrderPage";
import { ErrorPage } from "../pages/ErrorPage";

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<ProtectedRoute />}>
          <Route element={<TopPage />} path="/" />
          <Route element={<NoveltyCookieOrderPage />} path="/cookie" />
          {/*<Route element={<IrastPlateOrderPage />} path="/plate" />*/}
          <Route element={<PaymentConfirmPage />} path="/confirm" />
          <Route element={<OAuthCallbackPage />} path="/oauth/callback" />
        </Route>

        <Route element={<PublicRoute />}>
          <Route path="/login" element={<LoginPage />} />
        </Route>

        <Route element={<ThanksPage />} path="/thanks" />
        <Route element={<ErrorPage />} path="/error" />
      </Routes>
    </BrowserRouter>
  );
};
